import { ApiClient } from "../../../api-client";
import { ApiClientError } from "../../../errors";
import { TypeFromSchemaValidator } from "../../..";
import schemaValidators from "./schema-validators";

type FaceDetectedEvent =
	| TypeFromSchemaValidator<(typeof schemaValidators)["targetFaceDetectedEvent"]>
	| TypeFromSchemaValidator<(typeof schemaValidators)["otherFaceDetectedEvent"]>;

export class FaceDetectionLoggerClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClient["config"]) {
		super(config, schemaValidators);
	}

	async facesDetected(
		proctoringSessionId: string,
		{ who, count }: { who: FaceDetectedEvent["name"]; count: FaceDetectedEvent["details"]["count"] },
	) {
		try {
			const resp = await super.fetch(`${this.config.verityOrigin}/api/verity/quiz/event/${proctoringSessionId}`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					type: "face detection",
					name: who,
					time: new Date(),
					details: {
						count,
					},
				} satisfies FaceDetectedEvent),
				credentials: "include",
			});
			if (resp.ok) {
				return true;
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	}
}
